module.exports = __webpack_public_path__ + "img/img-7.81df85e3.jpg";